import { NetworkStatus } from '@cbridge-utils/network';
import { IOption } from '@cbridge-utils/options';
import { IClientLp } from '@cbridge-packages/lp-client';

export enum PricingMode {
  LpFailover = 'LP Failover',
  SymbolFailover = 'Symbol Failover',
  BasicAggregation = 'Basic Aggregation',
}

export enum AggregationMethod {
  SumVolumes = 'Sum Volumes',
  SeparateLP = 'Separate LP',
}

export interface IPricingProfile {
  id: number;
  name: string;
  mode: PricingMode;
  aggregationMethod?: AggregationMethod;
  lps: IOption<IClientLp['lpId']>[];
}

export interface ILpPriorityColumns {
  id: number;
  lp?: IOption<IClientLp['lpId']>;
}

export interface IPricingProfileForm {
  id: number;
  name: string;
  mode: PricingMode;
  aggregationMethod?: AggregationMethod;
  lps: ILpPriorityColumns[];
}

export interface IPricingProfileStore {
  data: Record<IPricingProfile['id'], IPricingProfile>;
  networkStatus: NetworkStatus;
}

export interface IPricingProfileStoreSegment {
  pricingProfile: IPricingProfileStore;
}
